import React from "react";
import { Helmet } from "react-helmet";
import { useLive } from "../LiveProvider";
import LiveHeader from "../common/LiveHeader";
import LiveRdcHorizontalBarChart from "./LiveRdcHorizontalBarChart";
import LiveRdcPoweredBy from "./LiveRdcPoweredBy";
import LiveRdcValueGrid from "./LiveRdcValueGrid";
import {
  Container,
  Description,
  PoweredByContainer,
  SubTitle,
  Title
} from "./styled/live-rdc";
import { ChartCard } from "./styled/live-rdc-buyer-demand";

function LiveRdcMarketDemand() {
  const { rdc, subjectProperty } = useLive();
  const byMarket = rdc.data?.buyers?.totalBuyers?.byMarket || 0;
  const byNeighbors = rdc.data?.buyers?.totalBuyers?.byNeighbors || 0;
  const totalValueBuffer = 0.1; // 10%
  let totalValue = Math.max(byMarket, byNeighbors);
  totalValue = totalValue * (1 + totalValueBuffer);

  return (
    <>
      <Helmet>
        <title>Test the Market With Buyer Demand</title>
      </Helmet>
      <LiveHeader>Test the Market With Buyer Demand</LiveHeader>
      <Container large>
        <Title>
          How strong is buyer demand in your market vs the surrounding area?
        </Title>
        <Description>
          Total buyers are those working with a known agent on Realtor.com® to
          search for homes of any price in your zip code, and in the ten closest
          zip codes. This visual below shows how active total buyers have been
          over the last 30 days.
        </Description>
        <SubTitle>Buyer demand</SubTitle>
        <ChartCard>
          <LiveRdcHorizontalBarChart
            totalValue={totalValue}
            primaryValue={byMarket}
            secondaryValue={byNeighbors}
            zipCode={subjectProperty.zip}
          />
        </ChartCard>
        <SubTitle>Why is this valuable?</SubTitle>
        <LiveRdcValueGrid
          items={[
            "If demand changes once the property is on the market, it's best to have alignment for how to adjust your listing strategy (marketing, contacting buyers, open houses, price, etc.).",
            "Your agent has access to tools on Realtor.com® to contact the buyers in your market and the surrounding area."
          ]}
        />
        <PoweredByContainer>
          <LiveRdcPoweredBy />
        </PoweredByContainer>
      </Container>
    </>
  );
}

export default LiveRdcMarketDemand;
